"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var TravelAgentModel_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravelAgentModel = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const legacy_models_1 = require("@daytrip/legacy-models");
const legacy_transformers_1 = require("@daytrip/legacy-transformers");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const travel_agent_tier_enum_1 = require("../enums/travel-agent-tier.enum");
const travelAgentCategoriesEligibleForAutoApproval = [
    legacy_enums_1.TravelAgentCategory.INTRAIL,
    legacy_enums_1.TravelAgentCategory.TAHAC,
    legacy_enums_1.TravelAgentCategory.TAHAD,
    legacy_enums_1.TravelAgentCategory.CITA,
];
let TravelAgentModel = TravelAgentModel_1 = class TravelAgentModel {
    constructor() {
        this.category = legacy_enums_1.TravelAgentCategory.DITA;
        this.currency = legacy_enums_1.Currency.Dollar;
        this.discountCoefficient = 0;
        this.commissionPercentage = 0;
        this.createdAt = new Date();
        this.partnerBookingAvailable = false;
        this.realizedOrders = 0;
        this.realizedOrdersCalculatedAt = new Date();
        this.tags = [];
        this.bizDevLeads = {}; // used to save different data for marketing biz dev team sales
        this.isHostAgencyAdmin = false;
        this.hasFirstOrderDiscountApplied = false;
    }
    get tier() {
        if (!this.realizedOrders || this.realizedOrders <= 0) {
            return undefined;
        }
        if (this.realizedOrders > 20) {
            return travel_agent_tier_enum_1.TravelAgentTier.Gold;
        }
        if (this.realizedOrders > 10) {
            return travel_agent_tier_enum_1.TravelAgentTier.Silver;
        }
        return travel_agent_tier_enum_1.TravelAgentTier.Bronze;
    }
    get status() {
        return (0, legacy_models_1.statusGetter)(this, TravelAgentModel_1, legacy_enums_1.TravelAgentStatus);
    }
    static statusPrototype(status) {
        const defined = new Date();
        switch (status) {
            case legacy_enums_1.TravelAgentStatus.Declined:
                return {
                    declinedAt: defined,
                };
            case legacy_enums_1.TravelAgentStatus.Approved:
                return {
                    declinedAt: undefined,
                    approvedAt: defined,
                };
            case legacy_enums_1.TravelAgentStatus.Pending:
            default:
                return {
                    declinedAt: undefined,
                    approvedAt: undefined,
                };
        }
    }
    get isEligibleForFirstOrderDiscount() {
        return !this.hasFirstOrderDiscountApplied;
    }
    get isApproved() {
        return Boolean(this.approvedAt && !this.declinedAt);
    }
    approve() {
        if (this.isApproved) {
            return;
        }
        this.approvedAt = new Date();
        this.declinedAt = undefined;
        this.declinationReason = undefined;
    }
    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }
    get eligibleForAutoApproval() {
        return travelAgentCategoriesEligibleForAutoApproval.includes(this.category);
    }
};
exports.TravelAgentModel = TravelAgentModel;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsUUID)("4", { always: true }),
    __metadata("design:type", String)
], TravelAgentModel.prototype, "_id", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEmail)(),
    (0, class_transformer_1.Transform)(({ value }) => value && value.trim().toLowerCase()),
    __metadata("design:type", String)
], TravelAgentModel.prototype, "email", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TravelAgentModel.prototype, "firstName", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TravelAgentModel.prototype, "lastName", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => legacy_enums_1.TravelAgentCategory),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.TravelAgentCategory),
    __metadata("design:type", String)
], TravelAgentModel.prototype, "category", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    __metadata("design:type", Number)
], TravelAgentModel.prototype, "currency", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(1),
    __metadata("design:type", Number)
], TravelAgentModel.prototype, "discountCoefficient", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    __metadata("design:type", Number)
], TravelAgentModel.prototype, "commissionPercentage", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    legacy_transformers_1.TransformToDate,
    __metadata("design:type", Date)
], TravelAgentModel.prototype, "approvedAt", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDate)(),
    legacy_transformers_1.TransformToDate,
    __metadata("design:type", Date)
], TravelAgentModel.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    legacy_transformers_1.TransformToDate,
    __metadata("design:type", Date)
], TravelAgentModel.prototype, "declinedAt", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsOptional)({ always: true }),
    (0, class_validator_1.IsUUID)("4", { always: true }),
    __metadata("design:type", String)
], TravelAgentModel.prototype, "countryId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TravelAgentModel.prototype, "declinationReason", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TravelAgentModel.prototype, "agentId", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TravelAgentModel.prototype, "hostAgencyId", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], TravelAgentModel.prototype, "partnerBookingAvailable", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)(({ value }) => (!value ? undefined : value)),
    __metadata("design:type", String)
], TravelAgentModel.prototype, "ownerId", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TravelAgentModel.prototype, "realizedOrders", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    legacy_transformers_1.TransformToDate,
    __metadata("design:type", Date)
], TravelAgentModel.prototype, "realizedOrdersCalculatedAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], TravelAgentModel.prototype, "tags", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsObject)(),
    __metadata("design:type", Object)
], TravelAgentModel.prototype, "bizDevLeads", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.ValidateIf)((agent) => !agent.hostAgencyId),
    __metadata("design:type", Boolean)
], TravelAgentModel.prototype, "isHostAgencyAdmin", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], TravelAgentModel.prototype, "hasFirstOrderDiscountApplied", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    legacy_transformers_1.TransformToDate,
    __metadata("design:type", Date)
], TravelAgentModel.prototype, "deletedAt", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => travel_agent_tier_enum_1.TravelAgentTier, { nullable: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], TravelAgentModel.prototype, "tier", null);
exports.TravelAgentModel = TravelAgentModel = TravelAgentModel_1 = __decorate([
    (0, type_graphql_1.ObjectType)("TravelAgent")
], TravelAgentModel);
//# sourceMappingURL=travel-agent.model.js.map